import { formatInTimeZone } from 'date-fns-tz';
import { CancellationWaitlistEntryDetail } from '../../types/cancellation-waitlist';
import {
  WAITLIST_DAY_LABELS,
  WAITLIST_TIME_LABELS,
} from '../../constants/cancellation-waitlist';

// Date-only columns come back as UTC midnight — format in UTC to avoid shifts.
const formatDbDate = (iso: string) =>
  formatInTimeZone(new Date(iso), 'UTC', 'MMM d, yyyy');

// Preference fields are Partial-picked: rows from an API deployed before the
// list endpoint returned preferences arrive without them, and "not present"
// should render the same as "no preference".
export function formatWaitlistWindow(
  entry: Partial<
    Pick<CancellationWaitlistEntryDetail, 'windowStartDate' | 'windowEndDate'>
  >,
) {
  const { windowStartDate: start, windowEndDate: end } = entry;
  if (start && end) return `${formatDbDate(start)} – ${formatDbDate(end)}`;
  if (start) return `From ${formatDbDate(start)}`;
  if (end) return `Until ${formatDbDate(end)}`;
  return 'Any dates';
}

export function formatWaitlistDays(
  entry: Partial<Pick<CancellationWaitlistEntryDetail, 'daysOfWeek'>>,
) {
  const days = entry.daysOfWeek ?? [];
  if (days.length === 0) return 'Any day';
  return days
    .slice()
    .sort((a, b) => a - b)
    .map(day => WAITLIST_DAY_LABELS[day])
    .join(', ');
}

export function formatWaitlistTimes(
  entry: Partial<Pick<CancellationWaitlistEntryDetail, 'timesOfDay'>>,
) {
  const times = entry.timesOfDay ?? [];
  if (times.length === 0) return 'Any time';
  return times.map(time => WAITLIST_TIME_LABELS[time]).join(', ');
}
